export default __webpack_public_path__ + "static/media/race-director-f-podium.a20a0a01.png";